import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {

	emailExists : function({ commit }, data){

		return new Promise((resolve, reject) => {

			var params = {
				email : data.email,
				filters : data.filters
			};

			api.post('validation/email-exists', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
	ssnExists : function({ commit }, data){

		return new Promise((resolve, reject) => {

			var params = {
				ssn : data.ssn,
				filters : data.filters
			};

			api.post('validation/ssn-exists', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	}
}

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/ValidationModule.js